import { render, staticRenderFns } from "./CProjectSummary.vue?vue&type=template&id=2abb41dc&scoped=true&"
import script from "./CProjectSummary.vue?vue&type=script&lang=js&"
export * from "./CProjectSummary.vue?vue&type=script&lang=js&"
import style0 from "./CProjectSummary.vue?vue&type=style&index=0&id=2abb41dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abb41dc",
  null
  
)

export default component.exports